import { TypedDocumentNode, gql } from '@apollo/client';
import { useIntl } from 'react-intl';
import styled from 'styled-components';

import { Auction } from '@sorare/core/src/assets/icons/Auction';
import { LabelS } from '@sorare/core/src/atoms/typography';
import { glossary } from '@sorare/core/src/lib/glossary';

import type { BidsCount_auction } from './__generated__/index.graphql';

interface Props {
  auction: BidsCount_auction;
}

const IconContainer = styled(Auction)`
  width: var(--intermediate-unit);
  height: var(--intermediate-unit);
  color: var(--c-nd-600);
`;

const Root = styled(LabelS).attrs({
  color: 'var(--c-nd-600)',
})`
  display: flex;
  align-items: center;
  gap: var(--half-unit);
`;

export const BidsCount = ({ auction }: Props) => {
  const { formatMessage } = useIntl();
  return (
    <Root aria-label={formatMessage(glossary.bids)}>
      {auction.bidsCount} <IconContainer />
    </Root>
  );
};

BidsCount.fragments = {
  auction: gql`
    fragment BidsCount_auction on TokenAuction {
      id
      bidsCount
    }
  ` as TypedDocumentNode<BidsCount_auction>,
};
